"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5512],{

/***/ 5512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ scrollIntoViewWithOffset; },
/* harmony export */   "l": function() { return /* binding */ isEventTargetSpecificTag; }
/* harmony export */ });
var isEventTargetSpecificTag = function(event, tagName) {
    return event.target.tagName.toUpperCase() === tagName.toUpperCase();
};
var scrollIntoViewWithOffset = function(ref, offset) {
    window.scrollTo({
        behavior: "smooth",
        top: (ref === null || ref === void 0 ? void 0 : ref.current.getBoundingClientRect().top) - document.body.getBoundingClientRect().top - offset
    });
};


/***/ })

}]);